const trustHtml = ["$sce", function ($sce) {
    return function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };
}]

export { trustHtml }
